





















































































































import {Component, Vue} from "vue-property-decorator";
import HpSmallText from "@/components/infrastructures/atoms/text/HpSmallText.vue";
import Copyright from "@/components/infrastructures/atoms/Copyright.vue";

@Component({
  components: {Copyright, HpSmallText}
})
export default class HomeFooter extends Vue {
  name = "HomeFooter"
  links = [
    {'name': 'トップ', 'link': '/#top'},
    {'name': 'サービス', 'link': '/#services'},
    {'name': '使い方と効果', 'link': '/#how-to-use'},
    {'name': '深層振動とは', 'link': '/#whats-dmv'},
    {'name': '論文紹介', 'link': '/#intro-papers'},
    {'name': '掲載メディア', 'link': '/#awards'},
  ];
  // 関連リンク（グループサイト）。一覧のマスターはリポジトリREADME「関連リンク一覧」を参照
  relatedGroups = [
    {
      title: 'サービス',
      links: [
        {'name': 'わたしのエステ', 'link': 'https://わたしのエステ.com/'},
        {'name': 'Dr.AI', 'link': 'https://dr-ai.health/'},
        {'name': 'Wellbeing Room', 'link': 'https://wellbeingroom.tokyo/'},
        {'name': '顔リズム', 'link': 'https://顔リズム.com/'},
      ],
    },
    {
      title: 'ペット',
      links: [
        {'name': 'ペットウェルネス', 'link': 'https://pet.wellbeingroom.tokyo/'},
      ],
    },
    {
      title: 'ショップ・スクール',
      links: [
        {'name': '公式ショップ', 'link': 'https://facetherapie.shop/'},
        {'name': 'スクール', 'link': 'https://tokyo-ft.com/'},
      ],
    },
    {
      title: '会社',
      links: [
        {'name': 'ファセテラピー', 'link': 'https://facetherapie.com/'},
      ],
    },
  ];
}
